module.exports = __webpack_public_path__ + "img/app-store-dark.0ce85dfb.svg";